<template>
    <h3 class="ui-popover-subtitle">
        <slot></slot>
    </h3>
</template>
